import 'swiper/css/bundle';
import Swiper from 'swiper';
import { Navigation, EffectCreative, Pagination } from 'swiper/modules';

Swiper.use([Navigation, EffectCreative, Pagination]);

const projectSwiper = new Swiper('.project-swiper', {
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    speed: 700,
    navigation: {
        nextEl: '.project-swiper-button-next',
        prevEl: '.project-swiper-button-prev',
    },
    pagination: {
        el: ".project-pagination",
        clickable: 'true',
    },
});
